@if (useDsRuleFilter) {
  <div class="col-12 col-md-auto mb-3 w-100 flex-grow-1">
    <form [formGroup]="formGroup">
      <ds-segmented-buttons
        data-test-id="rule-filter-status-selector"
        [options]="options"
        [formControlName]="FormField.status"
        [selectLabel]="'issues_filter_table_options' | translate"
        [ariaLabel]="'issues_filter_table_options' | translate"
      ></ds-segmented-buttons>
    </form>
  </div>
} @else {
  <div class="col-12 col-md-auto d-flex align-items-center mb-3">
    <div
      class="btn-group"
      role="radiogroup"
      [attr.aria-label]="'issues_filter_table_options' | translate"
      [formGroup]="formGroup"
    >
      <input
        type="radio"
        class="btn-check"
        id="failed-btn"
        [value]="issueStatus.failed"
        [formControlName]="FormField.status"
        [tabindex]="formGroup.controls.status.value === issueStatus.failed ? 0 : -1"
        (change)="onLegacyRadioChange(issueStatus.failed)"
        data-test-id="failed-btn"
      />
      <label class="btn btn-failed me-3" for="failed-btn">
        {{ 'issues_filter_status_failed' | translate }}
        <span class="badge">{{ failedRulesCount }}</span>
      </label>

      <input
        type="radio"
        class="btn-check"
        id="review-btn"
        [value]="issueStatus.review"
        [formControlName]="FormField.status"
        [tabindex]="formGroup.controls.status.value === issueStatus.review ? 0 : -1"
        (change)="onLegacyRadioChange(issueStatus.review)"
        data-test-id="review-btn"
      />
      <label class="btn btn-review me-3" for="review-btn">
        {{ 'issues_filter_status_flagged_for_review' | translate }}
        <span class="badge">{{ reviewRulesCount }}</span>
      </label>

      @if (!hidePassedRules) {
        <div>
          <input
            type="radio"
            class="btn-check"
            id="passed-btn"
            [value]="issueStatus.passed"
            [formControlName]="FormField.status"
            [tabindex]="formGroup.controls.status.value === issueStatus.passed ? 0 : -1"
            (change)="onLegacyRadioChange(issueStatus.passed)"
            data-test-id="passed-btn"
          />
          <label class="btn btn-passed me-3" for="passed-btn">
            {{ 'issues_filter_status_passed' | translate }}
            <span class="badge">{{ passedRulesCount }}</span>
          </label>
        </div>
      }
    </div>
  </div>
}
